module.exports = __webpack_public_path__ + "img/red_051.13a73bd3.png";